import { createFileRoute } from '@tanstack/react-router';
import { AgreementEditorPage } from '@/pages/member-portal/agreements/AgreementEditorPage';

// Agreement editor. `$id` is either an agreement id (edit) or the literal `new`.
function MemberPortalAgreementEditorRoute() {
	return <AgreementEditorPage />;
}

export const Route = createFileRoute('/_authenticated/_app/member-portal/manage/agreements/$id')({
	component: MemberPortalAgreementEditorRoute,
});
